export const remapLayoutLayer = layout => ({
  ...layout,
  pages: layout.pages.map(({ number, size, words }) => ({
    fields: words.map(({ boundingRegion, confidence, extractionFieldIntersection, value }) => {
      return {
        confidence,
        extractionFieldIntersection,
        value,
        boundingRegions: [{ boundingPolygon: boundingRegion.boundingPolygon }],
      };
    }),
    number,
    size,
  })),
});

export const filterFieldsIntersection = words =>
  words.filter(({ extractionFieldIntersection }) => !extractionFieldIntersection);

// Flattens a nested extraction-field-definition tree (`Children`) into a flat list, preserving
// every field's own properties (name, aiExtractionFieldName, etc.) — mirrors
// DocumentExtractionFieldsTab.utils.flattenExtractionFieldDefinitions for callers outside that
// module (this selector layer can't import from a component-local utils file).
export const flattenExtractionFieldDefinitionTree = fields =>
  (fields ?? []).reduce((acc, field) => {
    acc.push(field);

    if (field?.Children?.length) {
      acc.push(...flattenExtractionFieldDefinitionTree(field.Children));
    }

    return acc;
  }, []);

export const combineAiModelLayers = (firstLayerPages, secondLayerPages) => ({
  pages: firstLayerPages.map(({ fields, size, number }, index) => ({
    fields: [...fields, ...secondLayerPages[index]],
    size,
    number,
  })),
});

export const addIsMappedOnExtractionFieldFlag = ({ extractionResult, extractionFields }) => {
  const remappedPages = extractionResult.pages.map(page => {
    const adjustedFields = page.fields.reduce((acc, field) => {
      // The AI box's `schema.name` carries the field's human-readable label (e.g. "Document
      // Title"), not the field definition's machine-cased `aiExtractionFieldName` (e.g.
      // "documentTitle") — match on the definition's `name` instead.
      const isMappedOnExtractionField = extractionFields.some(
        ({ name }) => name === field.schema?.name,
      );

      return [...acc, { ...field, isMappedOnExtractionField }];
    }, []);

    return {
      ...page,
      fields: adjustedFields,
    };
  });

  return {
    ...extractionResult,
    pages: remappedPages,
  };
};
